import React from "react";
import { ThemeProvider } from "./src/components/context/theme-context";
import Layout from "./src/components/Layout";
import LayoutAd from "./src/components/LayoutAd";
import "./src/styles/global.css";

export const wrapPageElement = ({ element, props }) => (
  <ThemeProvider>
    {props.location.pathname.includes("portfolio") ? (
      <LayoutAd {...props}>{element}</LayoutAd>
    ) : (
      <Layout {...props}>{element}</Layout>
    )}
  </ThemeProvider>
);
